function playTone(audioContext, type, frequency, startTime, duration, peakGain) {
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);

  gainNode.gain.setValueAtTime(0.0001, startTime);
  gainNode.gain.exponentialRampToValueAtTime(peakGain, startTime + 0.02);
  gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.start(startTime);
  oscillator.stop(startTime + duration);

  return oscillator;
}

// Rising Chime: ascending major triad (C5 - E5 - G5).
export function playNotificationSound() {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;

    const audioContext = new AudioContextClass();
    const now = audioContext.currentTime;

    playTone(audioContext, "triangle", 523.25, now, 0.18, 0.42);
    playTone(audioContext, "triangle", 659.25, now + 0.12, 0.18, 0.44);
    const lastOscillator = playTone(audioContext, "sine", 784.0, now + 0.24, 0.34, 0.5);

    lastOscillator.onended = () => audioContext.close();
  } catch (error) {
    // Ignore playback failures (e.g. browser autoplay restrictions)
  }
}
